import { type AnchorHTMLAttributes } from "react";
import { t } from "@lingui/core/macro";
import { Icon } from "../icon";
import * as S from "./styled";

type DownloadLinkProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  "href" | "title"
> & {
  href: string | undefined;
  title: string;
  variant?: "plain" | "muted";
};

export const FileDownloadLink = ({
  href,
  title,
  children,
  variant = "muted",
  ...rest
}: DownloadLinkProps) => {
  const isDisabled = !href;
  return (
    <S.FileDownloadLink
      href={href}
      title={t`common.download-file ${title}`}
      $variant={variant}
      className={isDisabled ? "disabled-link" : undefined}
      tabIndex={isDisabled ? -1 : 0}
      {...rest}
    >
      {children}
      <Icon variant="FileDownload" />
    </S.FileDownloadLink>
  );
};
